<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >
    <template v-slot:activator="{ props }">
      <slot v-bind="{ props }"
            data-cy="podFiles-tree-actions-setAssetLanguage-activator"
            name="activator" />
    </template>

    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <span>{{ $t('routes.pod.setAssetLanguageDialogTitle') }}</span>

        <v-btn icon @click="dialog = false" :aria-label="$t('common.close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-form ref="form" v-on:submit.prevent="formSubmit()" data-cy="dialog-setAssetLanguage-modal">
        <v-card-text class="pb-0" data-cy="dialog-setAssetLanguage-selectLanguage">
          <v-select
            v-model="selectedLanguage"
            v-bind:items="languages"
            v-bind:rules="selectedLangRules"
            item-title="name"
            item-value="id"
            v-bind:label="$t('routes.pod.setAssetLanguageDialogSelect')"
            variant="solo-filled"
            :list-props="{
              tabindex: 0,
            }"
            flat required
          />

          <div v-if="errorMessage" class="bg-error" data-cy="dialog-setAssetLanguage-error">
            {{ errorMessage }}
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" type="submit" variant="flat" data-cy="dialog-setAssetLanguage-ok">
            {{ $t('common.submit') }}
          </v-btn>
          <v-btn variant="text" @click="dialog = false" data-cy="dialog-setAssetLanguage-false">
            {{ $t('common.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-form>

    </v-card>
  </v-dialog>
</template>

<script>
import { useCommonStore } from '@/stores/CommonStore.js'
import { usePodStore } from '@/stores/PodStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [DialogActionKeys, DialogModel],
  name: "AssetLanguageDialog",
  props: {
    pod: {
      type: Object,
      required: true,
    },
    asset: {
      type: Object,
      required: false
    }
  },
  data: function() {
    return {
      selectedLanguage: null,
      selectedLangRules: [
        v => !!v || this.$t('routes.pod.setAssetLanguageDialogRequied'),
      ],

      errorMessage: "",
    };
  },
  mounted: function() {
    this.setSelectedLanguage();
  },
  watch: {
    dialog: function(newValue) {
      if (newValue) {
        this.setSelectedLanguage();
        this.errorMessage = "";
      }
    }
  },
  methods: {
    setSelectedLanguage: function() {
      if (this.asset && this.asset.language) {
        const theLang = this.languages.find(x => x.id == this.asset.language);
        this.selectedLanguage = theLang ? theLang.id : null;
      } else {
        this.selectedLanguage = null;
      }
    },
    formSubmit: async function() {
      const { valid } = await this.$refs.form.validate();
      this.errorMessage = "";
      if (!valid) {
        return;
      }

      let data = {
        podID: this.pod.id,
        assetID: this.asset.id,
        languageID: this.selectedLanguage,
      };

      try {
        const podStore = usePodStore();
        await podStore.setAssetLanguage(data);
        this.dialog = false;
      } catch (error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          this.errorMessage = error.response.data.error.message;
        } else {
          this.errorMessage = "Error!";
          console.log(error);   // unhandled error
        }
      }
    },
  },
  computed: {
    languages: function() {
      const commonStore = useCommonStore();
      return commonStore.dbLanguages;
    }
  }
}
</script>

<style>

</style>
